import Button from '../../Common/Button';
import exportIcon from '../../../../assets/img/svg/buttons/export.svg';
import { useRef, useState } from 'react';
import ExportToExcel from './ExportToExcel';
import ExportToPDF from './ExportToPDF';
import { Visibility } from '../../../../enum/Visibility';
import { useOutsideFocus } from '../../../../hook/useOutsideFocus';

const MobileExport = () => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const openExportDropdown = () => {
    setOpenDropdown((prevState) => !prevState);
  };

  useOutsideFocus(openDropdown, () => setOpenDropdown(false), dropdownRef);

  return (
    <div className="export_wrapper" ref={dropdownRef}>
      <Button
        icon={exportIcon}
        onClick={openExportDropdown}
        className="export_button_mobile"
        variant={openDropdown ? 'filled' : 'outlined'}
      />
      <div className={`export_dropdown_mobile ${openDropdown ? Visibility.VISIBLE : Visibility.HIDDEN}`}>
        <div className="excel_container">
          <ExportToExcel className="excel_mobile" filled="outline" mobile={true} />
        </div>
        <hr />
        <div className="pdf_container">
          <ExportToPDF className="pdf_mobile" filled="outline" mobile={true} />
        </div>
      </div>
    </div>
  );
};

export default MobileExport;
